// extracted by mini-css-extract-plugin
module.exports = {"location":"styles_location__3Ie3g","content":"styles_content__72BYW"};